import { createSelector } from 'reselect';
import { reduxKey } from '../../constants';
import { getAllModules } from './modules';
export const getZones = (state)=>{
    var _state_reduxKey_layout, _state_reduxKey;
    return ((_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : (_state_reduxKey_layout = _state_reduxKey.layout) === null || _state_reduxKey_layout === void 0 ? void 0 : _state_reduxKey_layout.zones) || {};
};
export const getZone = createSelector(getZones, (_, zoneName)=>zoneName, (zones, zoneName)=>{
    var _zones;
    return (_zones = zones) === null || _zones === void 0 ? void 0 : _zones[zoneName];
});
export const getZoneModules = (state, type)=>{
    const zone = getZone(state, type);
    const modules = getAllModules(state);
    if (!zone || !modules) {
        return [];
    }
    return zone.installedModulesIds.map((id)=>modules[id]);
};
